export default "__VITE_PUBLIC_ASSET__27ffd52f__"